import type { SchoolDetail } from './types';

export const group2: Record<string, SchoolDetail> = {
  'british-butler-academy': {
    slug: 'british-butler-academy',
    lead:
      '英国・ロンドンに拠点を置く British Butler Academy（運営: Bespoke Bureau）。個人・グループ・2週間・モジュール・週末の5パターンの料金体系を持ち、「教室ではなく実際の環境で行う訓練」を掲げて、最大12名の少人数で実務型の執事訓練を提供する。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'British Butler Academy は、Bespoke Bureau が運営する英国・ロンドンの執事訓練機関です。公式サイト（bespokebureau.com）を拠点に、個人研修からグループ研修、2週間コース、個別モジュール、週末コースまで柔軟な形態で訓練を提供しています。「教室ではなく実際の環境で行う訓練」を掲げ、講師が世界各地へ出張する点も特徴です。',
      },
      {
        heading: '開催地・拠点',
        body: '所在地はロンドン中心部です。講師は世界各地への出張研修にも対応します。',
        table: [
          { label: '所在地', value: '7 Bell Yard, Strand, London WC2A 2JR, United Kingdom' },
          { label: '運営', value: 'Bespoke Bureau' },
          { label: '出張研修', value: '講師が世界各地へ出張' },
        ],
      },
      {
        heading: '沿革と創設者',
        body: '運営は Bespoke Bureau です。設立年や創設者の詳細な経歴は、正典ドキュメント上では公式の明記として扱っていません。',
        note: '設立年・創設者の詳細は公式サイトに記載なし',
      },
      {
        heading: '提供している課程',
        body: '期間は1日〜2週間（内容によりカスタム）です。コースは1週間〜4週間の設定もあります。個人研修・グループ研修・2週間コース・個別モジュール・週末コースなど、目的に応じた形態が用意されています。',
        table: [
          { label: '期間の基本', value: '1日〜2週間（内容によりカスタム）' },
          { label: 'コース設定の例', value: '1週間〜4週間の設定もあり' },
        ],
        bullets: [
          '個人研修',
          'グループ研修',
          '2週間コース（分割払い可）',
          '個別モジュール',
          '週末コース',
        ],
      },
      {
        heading: 'カリキュラムの科目',
        body: '公式が列挙する科目は次の12項目です。',
        bullets: [
          'シルバーサービス',
          'テーブル管理とサービスの流れ',
          'サービスのエチケットと言葉遣い',
          'VIP対応',
          '身だしなみとドレスコード',
          '立ち居振る舞いと姿勢',
          'コミュニケーション',
          '異文化理解',
          'ハウスキーピングの基準',
          '衛生と見せ方',
          '私邸での問題解決',
          '細部への注意と仕上げ',
        ],
      },
      {
        heading: '一日の流れ・学び方',
        body: '「教室ではなく実際の環境で行う訓練」を掲げています。実地の環境での訓練を重視し、講師が世界各地へ出張して研修を行う形態も取られます。',
        bullets: [
          '教室ではなく実際の環境で行う訓練（公式の掲げ）',
          '講師が世界各地へ出張',
        ],
      },
      {
        heading: '学費と支払条件',
        body: '公式 Butler Training ページ／検索時点の公開情報に基づく料金です。宿泊・食事は別料金です。為替換算は行いません。',
        table: [
          { label: '個人研修', value: '1日あたり £750（約16万円・2026-07-27時点）＋VAT' },
          { label: 'グループ研修', value: '1日あたり £1,250（約27万円・2026-07-27時点）＋VAT' },
          { label: '2週間コース', value: '£3,000（約65万円・2026-07-27時点）＋VAT（分割払い可）' },
          { label: '個別モジュール', value: '£500（約11万円・2026-07-27時点）＋VAT' },
          { label: '週末コース', value: '£800（約17万円・2026-07-27時点）＋VAT' },
          { label: '宿泊・食事', value: '別料金' },
        ],
        note: '料金は公式 Butler Training ページ／検索時点の公開情報。為替換算は行わない',
      },
      {
        heading: '定員と受講対象',
        body: '1コース最大12名です。対象として公式が示すのは次の4種です。',
        table: [{ label: '定員', value: '1コース最大12名' }],
        bullets: [
          'プライベートサービスへの新規参入者',
          '技能を磨きたい現役執事',
          'スタッフを育てたい家庭',
          'ホテル・ラグジュアリー事業者',
        ],
      },
      {
        heading: '応募資格と申込方法',
        body: '対象は新規参入者から現役執事、家庭、ホテル・ラグジュアリー事業者まで幅広く想定されています。具体的な応募資格の年齢制限や提出書類の一覧は、正典上では詳細が示されていません。',
        note: '応募資格の詳細・申込手順の詳細は公式サイトに記載なし（正典上の明示なし）',
      },
      {
        heading: '宿泊と食事',
        body: '宿泊・食事は学費に含まれず、別料金です。',
        bullets: ['宿泊は別料金', '食事は別料金'],
        note: '宿泊先の手配支援の有無など、詳細条件は公式サイトに記載なし',
      },
      {
        heading: '講師',
        body: '講師は「超富裕層家庭、王室環境、一流ホスピタリティで働いた経験を持つ professionals」と公式に示されています。',
        bullets: [
          '超富裕層家庭での勤務経験を持つ professionals',
          '王室環境での勤務経験を持つ professionals',
          '一流ホスピタリティでの勤務経験を持つ professionals',
        ],
      },
      {
        heading: '認定・受賞',
        body: '修了時に The British Butler Academy の証明書が授与されます。特に優秀な者には個別の推薦状が発行されます。',
        bullets: [
          '修了時: The British Butler Academy の証明書',
          '特に優秀な者: 個別の推薦状',
        ],
      },
      {
        heading: '修了後の進路と就職支援',
        note: '公式サイトに記載なし',
      },
      {
        heading: '言語',
        note: '使用言語は公式サイトに記載なし',
      },
      {
        heading: '特徴のまとめ',
        body: '料金は個人・グループ・2週間・モジュール・週末の5パターン。宿泊・食事は別料金。期間は1日〜2週間を基本に、1〜4週間の設定もあります。定員は最大12名。「教室ではなく実際の環境で行う訓練」を掲げ、実際の環境での実務型訓練と出張研修が特徴です。',
      },
    ],
    sources: [
      {
        label: 'British Butler Academy 公式（Bespoke Bureau）',
        url: 'https://www.bespokebureau.com/butler-academy/butler-school/',
      },
    ],
  },

  'charles-macpherson-academy': {
    slug: 'charles-macpherson-academy',
    lead:
      'カナダ・トロントの The Charles MacPherson Academy。2009年設立の private career college で、バトラー及びハウスホールドマネージャー向け教育を行う。オンライン校は2022年開設（トップに「Since 2008」表記あり）。人材紹介・教育訓練・富裕層家庭へのコンサルティングの3事業を展開する。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'The Charles MacPherson Academy は、バトラー及びハウスホールドマネージャー向けの private career college（私立キャリアカレッジ）です。カナダ・トロントに所在し、対面の Hotel Butler 201 と、2022年開設のオンライン校の双方を展開しています。事業は人材の採用・紹介、私的サービス職の教育訓練、富裕層家庭へのコンサルティングの3種です。',
        bullets: [
          'private career college（私立キャリアカレッジ）',
          '対象: バトラー及びハウスホールドマネージャー',
          '事業: 人材の採用・紹介',
          '事業: 私的サービス職の教育訓練',
          '事業: 富裕層家庭へのコンサルティング',
        ],
      },
      {
        heading: '沿革と創設者',
        body: '設立は2009年（About ページ）です。一方、オンライン校のトップは「Educating Private Service Professionals Since 2008」と表記しており、表記に差異があるため両方を併記します。創設者は Charles MacPherson 氏で、公式 About ページに設立の経緯が記載されています。オンライン校は2022年に開設されました。',
        table: [
          { label: '設立（About ページ）', value: '2009年' },
          {
            label: 'オンライン校トップの表記',
            value: 'Educating Private Service Professionals Since 2008',
          },
          { label: 'オンライン校の開設', value: '2022年' },
          { label: '創設者', value: 'Charles MacPherson 氏' },
        ],
        note: '設立年について、About ページの2009年とオンライン校の「Since 2008」表記に差異があるため両方を併記',
      },
      {
        heading: '開催地・拠点',
        body: 'カナダ・トロントに所在します。オンライン校は academy.charlesmacpherson.com で提供されます。',
        table: [
          {
            label: '所在地',
            value: '260 Adelaide Street East P.O. Box 82, Toronto, Ontario M5A 1N1, Canada',
          },
          { label: '公式（Academy 紹介）', value: 'https://www.charlesmacpherson.com/about-the-academy/' },
          { label: 'オンライン校', value: 'https://academy.charlesmacpherson.com/' },
        ],
      },
      {
        heading: '提供している課程',
        body: 'オンライン校では Household Management の ADVANCED / STANDARD（各5週間）に加え、テーブルセッティングやアフタヌーンティー、キャビア、ゲストアナウンスなどの単科講座があります。対面課程として Hotel Butler 201（In person program）があり、受講は雇用主による申込者に限定されます。',
        bullets: [
          'Fundamentals of Household Management: ADVANCED PROGRAM（5週間・オンライン）',
          'Fundamentals of Household Management: STANDARD PROGRAM（5週間・オンライン）',
          'How To Set The Table Around The World（オンライン単科）',
          'An Introduction to Afternoon Tea（オンライン単科）',
          'Caviar for Beginners（オンライン単科）',
          'How to Announce Guests to the Table（オンライン単科）',
          'Hotel Butler 201（対面・In person program・雇用主による申込者限定）',
        ],
      },
      {
        heading: 'カリキュラムの科目',
        body: '対面課程 Hotel Butler 201 のモジュールは次の10項目です（Core 101 の復習から総括まで）。',
        bullets: [
          'Core 101 の復習',
          'ゲストとの関係構築（1）',
          'ゲストとの関係構築（2）',
          'サービスリカバリー',
          '優先順位と時間管理',
          'ゲストプロファイル',
          'サービスの一貫性',
          'MGM SOP',
          'インビジブルサービス',
          '総括',
        ],
        note: 'オンライン各講座の詳細シラバスは、正典上ではモジュール名の列挙に留まらない部分は記載なし',
      },
      {
        heading: '学費と支払条件',
        body: 'オンライン校の公表価格です。通貨表記はドルです。為替換算は行いません。対面課程（Hotel Butler 201）の期間・料金は公式に記載がありません。',
        table: [
          {
            label: 'Fundamentals of Household Management: ADVANCED PROGRAM',
            value: '5週間・$6,000（約98万円・2026-07-27時点）',
          },
          {
            label: 'Fundamentals of Household Management: STANDARD PROGRAM',
            value: '5週間・$3,000（約49万円・2026-07-27時点）',
          },
          { label: 'How To Set The Table Around The World', value: '$750（約12万円・2026-07-27時点）' },
          { label: 'An Introduction to Afternoon Tea', value: '$49.95（約8,200円・2026-07-27時点）' },
          { label: 'Caviar for Beginners', value: '$49.95（約8,200円・2026-07-27時点）' },
          { label: 'How to Announce Guests to the Table', value: '$49.95（約8,200円・2026-07-27時点）' },
        ],
        note: '対面課程（Hotel Butler 201）の期間・料金は公式サイトに記載なし。通貨はドル表記（公式オンライン校の公表価格）',
      },
      {
        heading: '定員と受講対象',
        body: 'バトラー及びハウスホールドマネージャー向けです。対面の Hotel Butler 201 は、雇用主による申込者に限定されます。',
        bullets: [
          'バトラー向け',
          'ハウスホールドマネージャー向け',
          'Hotel Butler 201: 雇用主による申込者に限定',
        ],
        note: '定員の具体数は公式サイトに記載なし',
      },
      {
        heading: '応募資格と申込方法',
        body: '対面課程 Hotel Butler 201 は、雇用主による申込者に限定されます。オンライン講座の一般的な申込条件の詳細は、正典上では深く示されていません。',
        bullets: ['Hotel Butler 201: 受講は雇用主による申込者に限定'],
        note: 'オンライン講座の応募資格・申込手順の詳細は公式サイトに記載なし（正典上の明示なし）',
      },
      {
        heading: '宿泊と食事',
        body: 'オンライン課程が中心の公表体系であり、宿泊・食事込みの通学型パッケージとしての記載はありません。',
        note: '宿泊・食事の条件は公式サイトに記載なし',
      },
      {
        heading: '事業内容',
        body: '公式が示す事業は次の3種です。',
        bullets: [
          '人材の採用・紹介',
          '私的サービス職の教育訓練',
          '富裕層家庭へのコンサルティング',
        ],
      },
      {
        heading: '認定・受賞',
        note: '認定・受賞の具体名は公式サイトに記載なし（正典上の明示なし）',
      },
      {
        heading: '修了後の進路と就職支援',
        body: '事業の一つとして人材の採用・紹介を行っています。教育訓練と併せ、私的サービス職への人材面の支援が事業範囲に含まれます。',
        bullets: ['人材の採用・紹介（事業の一環）'],
        note: '就職率などの数値は公式サイトに記載なし',
      },
      {
        heading: '言語',
        note: '使用言語は公式サイトに記載なし',
      },
    ],
    sources: [
      {
        label: 'The Charles MacPherson Academy（About）',
        url: 'https://www.charlesmacpherson.com/about-the-academy/',
      },
      {
        label: 'Charles MacPherson オンライン校',
        url: 'https://academy.charlesmacpherson.com/',
      },
    ],
  },

  'magnums-academy': {
    slug: 'magnums-academy',
    lead:
      'オーストラリア・クイーンズランドの Magnums Academy（Magnums Butlers）。1987年から30年以上にわたり訓練を実施。Principal / Director の Josephine Ive 氏（公式が「UK\'s First Female Butler」と紹介）を中心に、商標登録された手法と6つのプログラムでラグジュアリーサービス教育を提供する。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'Magnums Academy（Magnums Butlers）は、オーストラリア・クイーンズランドを拠点とする執事・ラグジュアリーサービス訓練機関です。1987年から訓練を実施し、30年以上の実績があります。5つ星ホテル、王宮、スーパーヨットのクルー、Fortune 100/500 の私邸を顧客とし、修了生は40か国以上で就業しています。',
      },
      {
        heading: '沿革と創設者',
        body: '1987年から訓練を実施（30年以上）しています。Principal / Director は Josephine Ive 氏です。公式は「UK\'s First Female Butler」と紹介しており、エリザベス女王、クイーンマザー、英国高等法院判事の執事を務めた経歴があるとされます。',
        bullets: [
          '実績年: 1987年から訓練を実施（30年以上）',
          'Principal / Director: Josephine Ive 氏',
          '公式の紹介: 「UK\'s First Female Butler」（公式の紹介文言）',
          '経歴: エリザベス女王の執事',
          '経歴: クイーンマザーの執事',
          '経歴: 英国高等法院判事の執事',
        ],
      },
      {
        heading: '開催地・拠点',
        body: 'オーストラリア・クイーンズランドを拠点とします。',
        table: [
          { label: '拠点', value: 'オーストラリア・クイーンズランド' },
          { label: '公式', value: 'https://www.magnumsacademy.com/' },
          { label: 'メール', value: 'josephine@magnumsacademy.com' },
          { label: '電話', value: '+61 419 533 834' },
        ],
      },
      {
        heading: '講師',
        body: '講師陣は「ラグジュアリーサービスの経験を合計100年分」持つと公式に記載されています。Principal / Director の Josephine Ive 氏は、公式が「UK\'s First Female Butler」と紹介し、エリザベス女王・クイーンマザー・英国高等法院判事の執事を務めた経歴を持ちます。',
        bullets: [
          '講師陣: ラグジュアリーサービスの経験を合計100年分（公式の記載）',
          'Josephine Ive 氏: 公式が「UK\'s First Female Butler」と紹介',
          'Josephine Ive 氏: エリザベス女王・クイーンマザー・英国高等法院判事の執事経歴',
        ],
      },
      {
        heading: '提供している課程',
        body: '公式が示すプログラムは次の6つです。課程期間・料金は公式に記載がありません。',
        bullets: [
          '7 Star Service™（看板の執事サービス訓練）',
          'PULSE（Perfecting Ultimate Luxury Services Experiences）',
          'Quality Ambassador™（異文化理解とグローバル接客）',
          'Leadership & Cultural Intelligence（ホテル向けリーダーシップ）',
          'IAMI GUEST（ヨットとヨットライフ入門）',
          'Bespoke Consulting（Forbzology™ による基準整合）',
        ],
        note: '課程期間・料金は公式サイトに記載なし',
      },
      {
        heading: 'プログラムの内容',
        body: '各プログラムの公式上の位置づけ・内容は次のとおりです。',
        table: [
          { label: '7 Star Service™', value: '看板の執事サービス訓練' },
          {
            label: 'PULSE',
            value: 'Perfecting Ultimate Luxury Services Experiences',
          },
          {
            label: 'Quality Ambassador™',
            value: '異文化理解とグローバル接客',
          },
          {
            label: 'Leadership & Cultural Intelligence',
            value: 'ホテル向けリーダーシップ',
          },
          { label: 'IAMI GUEST', value: 'ヨットとヨットライフ入門' },
          {
            label: 'Bespoke Consulting',
            value: 'Forbzology™ による基準整合',
          },
        ],
      },
      {
        heading: '商標',
        body: '公式が示す商標は次の3つです。',
        bullets: [
          '7 Star Service™（世界で通用するラペルピン）',
          'The Magnums Method™',
          'Forbzology™',
        ],
      },
      {
        heading: '学費と支払条件',
        body: '課程期間・料金ともに、公式サイトへの記載はありません。為替換算も行いません。',
        note: '課程期間・料金は公式サイトに記載なし',
      },
      {
        heading: '定員と受講対象',
        body: '顧客として公式が示すのは次の4種です。定員の具体数は公式に記載がありません。',
        bullets: [
          '5つ星ホテル',
          '王宮',
          'スーパーヨットのクルー',
          'Fortune 100/500 の私邸',
        ],
        note: '定員の具体数は公式サイトに記載なし',
      },
      {
        heading: '応募資格と申込方法',
        body: '問い合わせ先としてメールと電話が公式に示されています。応募資格の詳細は正典上に明記がありません。',
        table: [
          { label: 'メール', value: 'josephine@magnumsacademy.com' },
          { label: '電話', value: '+61 419 533 834' },
        ],
        note: '応募資格・申込手順の詳細は公式サイトに記載なし',
      },
      {
        heading: '宿泊と食事',
        note: '公式サイトに記載なし',
      },
      {
        heading: '認定・受賞',
        body: 'IAMI GUEST 認定が公式に示されています。また 7 Star Service™ は世界で通用するラペルピンとして商標されています。',
        bullets: ['IAMI GUEST 認定', '7 Star Service™（世界で通用するラペルピン）'],
      },
      {
        heading: '修了後の進路と就職支援',
        body: '修了生は40か国以上で就業しています。就職率などの数値や、公式の就職斡旋部門の有無については正典上の記載がありません。',
        table: [{ label: '修了生の就業', value: '40か国以上で就業' }],
        note: '就職率・斡旋体制の詳細は公式サイトに記載なし',
      },
      {
        heading: '言語',
        note: '使用言語は公式サイトに記載なし',
      },
    ],
    sources: [
      { label: 'Magnums Academy 公式', url: 'https://www.magnumsacademy.com/' },
    ],
  },
};
